/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React, {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import { useQueryParams, StringParam } from 'use-query-params';

import { ColorProfiles, QueryParamNames } from '@powdr/constants';

import { RatesAndDatesGroup } from './components';
import {
  StyledRatesAndDatesTabs, TabButton, TabContentWrapper, Tabs,
} from './styles';

const ratesDatesParams = {
  [QueryParamNames.TAB]: StringParam,
};

export const RatesAndDatesTabs = ({
  activeParentTab,
  panelTag = null,
  relationships,
}) => {
  const groups = useMemo(() => relationships?.groups || [], [relationships]);
  const [activeTab, setActiveTab] = useState(0);
  const [urlQueryParams] = useQueryParams(ratesDatesParams);

  const getActiveTabFromParams = useCallback(
    () => groups.findIndex(
      (t) => t.title.toUpperCase() === urlQueryParams?.[QueryParamNames.TAB]?.toUpperCase(),
    ),
    [groups, urlQueryParams],
  );

  useEffect(() => {
    if (urlQueryParams?.[QueryParamNames.TAB] && groups?.length > 1) {
      setActiveTab(getActiveTabFromParams());
    }
  }, [urlQueryParams, getActiveTabFromParams, groups]);

  useEffect(() => {
    setActiveTab(0);
  }, [activeParentTab]);

  if (!groups || groups.length === 0) return null;

  return (
    <StyledRatesAndDatesTabs>
      <Tabs>
        {(groups.length > 1) && groups.map((group, idx) => (
          <TabButton
            $isActive={idx === activeTab}
            onClick={() => setActiveTab(idx)}
            $colorProfile={ColorProfiles.BASE}
          >
            {group.title}
          </TabButton>
        ))}
      </Tabs>
      <TabContentWrapper>
        <RatesAndDatesGroup data={groups[activeTab]} panelTag={panelTag} />
      </TabContentWrapper>
    </StyledRatesAndDatesTabs>
  );
};

RatesAndDatesTabs.propTypes = {
  relationships: PropTypes.shape({
    groups: PropTypes.arrayOf({}),
  }).isRequired,
  activeParentTab: PropTypes.number.isRequired,
  panelTag: PropTypes.string,
};
